import React from 'react'
import { getSaberChartTheme } from '../theme'

// Custom recharts tooltip styled to follow the global light/dark theme via
// theme.ts. Recharts passes `active`, `payload`, and `label` at render time.
export interface ChartTooltipPayloadItem {
  name?: string | number
  value?: number | string
  color?: string
}

export interface ChartTooltipProps {
  active?: boolean
  label?: string | number
  payload?: ChartTooltipPayloadItem[]
  /** Prefix prepended to numeric values, e.g. '$'. */
  prefix?: string
}

export const ChartTooltip: React.FC<ChartTooltipProps> = ({ active, label, payload, prefix = '' }) => {
  if (!active || payload == null || payload.length === 0) return null
  const theme = getSaberChartTheme()
  return (
    <div
      className="rounded-md px-3 py-2 text-xs shadow-lg"
      style={{
        backgroundColor: theme.tooltipBg,
        border: `1px solid ${theme.tooltipBorder}`,
        color: theme.tooltipText
      }}
    >
      {label != null && <div className="mb-1 font-medium opacity-70">{label}</div>}
      {payload.map((item, index) => (
        <div key={index} className="flex items-center gap-2">
          <span className="inline-block h-2 w-2 rounded-full" style={{ backgroundColor: item.color }} />
          <span>
            {item.name}: {prefix}
            {typeof item.value === 'number' ? item.value.toLocaleString() : item.value}
          </span>
        </div>
      ))}
    </div>
  )
}

export default ChartTooltip
